// extracted by mini-css-extract-plugin
module.exports = {"detailsContainer":"_2T7IyEFqHnxY9VIjeFhIlf","key":"m8ne8NV0HCR9Db6u7TjQ8"};